const React = require('react');

module.exports = class State extends React.Component {
  constructor(props) {
    super();
    this.state = props.initialState || {};
  }

  setState = this.setState.bind(this);

  render() {
    const { state, setState } = this;
    return this.props.children({ state, setState });
  }
};
